// extracted by mini-css-extract-plugin
module.exports = {"animation":"content_animation__UDyFs","animation-playing":"content_animation-playing__x9PnM","animation-complete":"content_animation-complete__MHEx_"};